import moment from "moment";
import { traceDefaultDelays, traceDefaultSpeeds,emptyArray } from "../constants";
import {defaultRouteRequest} from "../bl/routeRequestUtils";

export default {
  profile: null,
  isPaidUser: false,
  isInitialized: false,
  isWelcomeScreen: true,
  isRouteSearching: false,
  isRouteSearchFailed: false,
  showResults: false,
  showLightVersion: false,
  showLegendPopup: false,
  /**
   * Элементы автокомплита, которые возвращает текущий контрол Autosuggest
   */
  suggestions: [],

  /**
   * Используется для хранения информации о маршруте, полученной из query string (сырые данные).
   * Мониторится ReduxQuerySyncEnhancer-ом для синхронизации адресной строки с этим объектом.
   */
  routeQueryParams: {
    type: undefined,
    cityId: undefined,
    geoPoint: undefined,
    address: undefined
  },

  /**
   * Маршрут (последовательность точек), для которого четко найдены точки в системе
   */
  routeRequest: defaultRouteRequest,

  /**
   * Ограничения, влияющие на построение маршрута
   */
  restrictions: {
    excludeTollRoads: false,
    withinCountry: true,
    excludeMkad: false,
    allowFerries: false,
    allowWinterRoads: false,
    fastWay: true,
    useBelarusRule: false,
  },

  calculations: {
    departureDate: moment().startOf('day'),
    departureHour: 9,
    departureMinute: 0,
    fuelConsumption: 28,
    fuelPrice: 80,
    workingDay: 8,
    dailyMileage: 500
  },

  speeds: traceDefaultSpeeds,
  delays: traceDefaultDelays,

  /** @type {City[]} */
  excludedCities: emptyArray,
  /** @type {Country[]} */
  excludedCountries: emptyArray,

  commonStats: {
    trucks: 0,
    loads: 0,
    members: 0,
  },

  routeNotFound: false,
  routeWithoutRestrictions: false,
  sidebarToggled: false,

  pendingRequests: 0,

  /**
   * Информация о маршруте
   */
  routeInfo: {
    segments: []
  },
  /**
   * Визуальная часть маршрута, что отображается на карте.
   */
  visualRoute: {
    routeId: undefined,
    segments: []
  },
  platonRate: 1,
  
  metrics: {
    totalDistance: 0,
    totalPlatonCost: 0,
    fuelPrice: 0,
    fuelConsumption: 0,
    totalFuelCosts: 0,
    totalFuelConsumption: 0,
    totalHours: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    routeSegments: []
  },
  showPassingCitiesInRouteDetails: false,
  /** Ошибки, возникшие при поиске 
   * @type {SearchRouteError} */
  searchRouteError: undefined
};
